// src/lang/zh-CN.js （简体中文）
export default {
    menu: {
        home: '首页',
        about: '关于我们',
        aboutGroup: '集团介绍',
        corporateCulture: '品牌文化',
        brandHistory: '品牌历史',
        brandPromotion: '品牌推广',
        news:'集团新闻',
        productShowcase:'集团产品',
        teaSeries: '茶业系列',         // 茶业系列（泛指茶叶相关产品）
        teaDrinkSeries: '茶饮系列',  // 茶饮系列（强调饮品形态）
        teaSetSeries: '茶器系列',  // 茶器系列（茶具、器皿类）
        teaBanquetSeries: '茶宴系列', // 茶宴系列（茶主题宴席）
        teaCabinSeries: '茶舱系列',     // 茶舱系列（若指茶空间/仓储相关）
        groupControl:'集团管控',
        jobRecruitment:'人才招纳',
        socialResponsibility: '社会责任',  // 社会责任
        publicWelfare: '公益帮扶助力',        // 公益帮扶助力
        agricultureView: '三农优选计划',     // 三农优选计划（"三农"为大陆术语，繁体中可直接使用，或根据受众调整为"農業、農村、農民"相关表述）
        villageView: '乡村振兴战略',         // 乡村振兴战略
        healthyChina: '健康中国品牌',        // 健康中国品牌
        contact: '联系我们'                  // 联系我们
    },
    message: {
        langSwitchSuccess: '切换语言成功',
        langChinese: '已为您切换至中文简体模式',
        langTaiwan: '已为您切换至中文繁体模式', // 新增繁体提示
        langEnglish: '已为您切换至英文模式' // 新增英文提示
    },
    products: {
      title: '系列产品'  // 对应“系列产品”的键
    },
    AboutUsSection:{
        title: '构筑百年企业    传承荆楚文化',
        text: '三皮罐，源于荆楚民间传统，承载着 400 年的文化记忆。相传神农尝百草时发现，三片海棠叶入罐冲泡，七日不馊，故得名 " 三皮罐 "。这一独特的茶饮文化，深深植根于荆楚大地，见证了代代相传的生活智慧。',
        text2: '作为中国大健康产业品牌运营商，三皮罐集团积极响应 "健康中国 2030" 战略和 "三茶统筹" 理念，将茶文化、茶产业、茶科技深度融合，我们不止于做茶，更在缔造一种健康、自然、可持续的生活方式，致力于打造具有荆楚特色的茶文化服务综合体和多元化产业格局。',
        text3: '集团扎根荆楚，胸怀世界，在北京、上海、武汉、广州、深圳、成都、重庆等城市设立城市办公室，在香港设立国际中枢平台。以万亩茶园为根基，依托优质水源，运用现代茶科技，建设智能化超级工厂、天下茶舱、源茶基地、天然水基地等重点项目。致力于将千年茶香与现代健康消费完美融合，以三皮罐茶、水、器、时、空五大产品线对话世界。'
    },
    AboutUsSectionStats: {
        farm: '种植基地',
        factory: '超级工厂',
        experience: '服务经验',
        city: '覆盖城市',
        unitMu: '亩', // 亩（面积单位）
        unitYear: '年', // 年（时间单位）
        unitPlus: '+' // 加号后缀
    },
    brandProText: {
        title: '三皮罐大健康',
        slogan: '自然、健康、正能量',
        description: '三皮罐的魅力，在于它用最简单的原料和工艺，诠释了 “大道至简” 的东方智慧。无论是传统冲泡的质朴，还是现代罐装的便捷，它始终以 “天然、健康、回甘” 为核心，既承载着四百年的文化记忆，又满足着现代人们对健康品质生活的追求。正如三皮罐集团总经理鲜文亮所言：“我们不是在做饮料，而是在传递一种生活方式。” 这种将自然、传统与创新融为一体的特质，让三皮罐成为一款值得品味、收藏和分享的 “有故事的产品”。'
    },
    sectionRenewal: {
        title: '5X焕新而来',
        subtitle: '传荆楚文脉 • 造健康生活'
    },
    moreBtn:'了解更多',
    fiveXItems: [
        {
            title: '茶',
            relationship: '茶业',
            icon: 'icon-chaye',
            description: '荆楚文化的味觉名片'
        },
        {
            title: '水',
            relationship: '茶饮',
            icon: 'icon-chayin',
            description: '草本饮品中的惊喜'
        },
        {
            title: '器',
            relationship: '茶器',
            icon: 'icon-chaqi',
            description: '一罐传千年'
        },
        {
            title: '时',
            relationship: '茶境',
            icon: 'icon-chajing',
            description: '荆楚茶韵的体验高地'
        },
        {
            title: '空',
            relationship: '茶界',
            icon: 'icon-chajie',
            description: '生态空间矩阵'
        }
    ],
    EnterpriseNewsTitle:'企业动态',
    ViewDetails:'查看详情',
    FooterBar:{
        title:'服务热线',
        menuTitle:'关于我们',
        about:'集团介绍',
        Culture:'品牌文化',
        news:'新闻动态',
        qxtitle:'旗下产品',
        chaye:'茶业',
        chayin:'茶饮',
        chaqi:'茶器',
        chayan:'茶宴',
        chacang:'茶舱',
        responsibility:'责任与公益',
        publicWelfare:'公益之行',
        responsibilityView:'社会责任',
        Copyright:'版权所有 三皮罐大健康产业集团',
        siteMapView:'网站地图',
        adminLogin:'管理登录',
        ImageUploader:'上传图片'
    },
    proCultureImages: {
        culture1: 'https://pic1.imgdb.cn/item/68f9a1f53203f7be00909694.png',
        culture2: 'https://pic1.imgdb.cn/item/68fb7ce73203f7be00988e67.png',
        culture3: 'https://pic1.imgdb.cn/item/68f9a1f53203f7be00909696.png',
        culture4: 'https://pic1.imgdb.cn/item/68f9a1f53203f7be00909699.png',
        culture5: 'https://pic1.imgdb.cn/item/68f9a1f53203f7be0090969a.png'
    }
}
